import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterService } from 'src/app/_services/toaster.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { PosterService, EventService } from 'src/app/_services/generatedServices';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { CreatePosterViewModel, ConferenceViewModel, PosterSessionViewModel, PosterViewModel, FileType, ConferenceViewModelSimple } from 'src/app/_models/generatedModels';
import { Subscription } from 'rxjs';
import { NavigationService } from 'src/app/_services/navigation-service';
import { Enums } from 'src/app/_models/generatedEnums';

@Component({
  selector: 'bxl-call-for-posters',
  templateUrl: 'call-for-posters.component.html',
})
export class CallForPostersComponent implements OnInit, OnDestroy {
  private routeSubscription: Subscription;
  posterId: any;
  uploadUrl: string;
  initialized = false;
  FileTypeEnum = Enums.FileTypeEnum;
  additionalAuthors: FormArray;
  submitComplete: Promise<{}> | undefined;
  public formGroup: FormGroup;
  imageChangedEvent: any = '';
  imageChangedEventThumb: any = '';
  croppedImage: any = '';
  croppedImageThumb: any = '';
  initialCroppedImage: string;
  initialCroppedImageThumb: string;
  modalImage: any;
  modalImageThumb: any;
  conferences: ConferenceViewModelSimple[];
  sessions: PosterSessionViewModel[];
  poster: PosterViewModel;
  posterAssetPath: string;
  posterThumbnailPath: string;
  authSubscription: Subscription;
  organizationId: string;

  constructor(private route: ActivatedRoute, private location: Location, public nav: NavigationService, private eventService: EventService,  private toastr: ToasterService, public auth: AuthenticationService, private posterService: PosterService, private modalService: NgbModal, private fb: FormBuilder) {
    this.nav.pageTitle = 'Call For Posters';
  }

  ngOnInit(): void {
    this.uploadUrl = '/api/uploadMaterials';

      this.routeSubscription = this.route.paramMap.subscribe((param) => {
        this.posterId = param.get('id');
        this.organizationId = param.get('organizationId');
        console.log(this.organizationId);

        if (this.auth.isLoggedIn()) {
          this.loadPage();
        } else {
          this.authSubscription = this.auth.loggedIn.subscribe((result) => {
            this.loadPage();
          });
        }
    });
  }

  loadPage() {
    if (this.posterId != null) {
      this.posterService.getPosterById(this.posterId).subscribe((poster) => {
        this.poster = poster;
        this.populateDropdowns();
      });
    } else {
      this.poster = new PosterViewModel();
      this.populateDropdowns();
    }
  }

  populateDropdowns() {
    this.eventService.getUpcomingConferences(true).subscribe((conferences) => {
      console.log(this.conferences);
      if (this.organizationId) {
        this.conferences = conferences.filter((x) => x.showPosters && x.organization.slug === this.organizationId);
      } else {
        this.conferences = conferences.filter((x) => x.showPosters);
      }
      console.log(this.conferences);
      this.posterService.getPosterSessionsForConference(this.conferences[0].id).subscribe((sessions) => {
        this.sessions = sessions;
        this.setupForm();
      });
    });
  }

  setupForm(): any {
    var affiliation = '';

    if (this.poster.authors) {
      var leadAuthor = this.poster.authors.find((x) => x.id == this.auth.user.id);
      if (leadAuthor) {
        affiliation = leadAuthor.affiliation;
      }
    }
    this.formGroup = this.fb.group({
      title: [this.poster.title, [Validators.required, Validators.maxLength(255)]],
      affiliation: [affiliation, [Validators.required]],
      additionalAuthors: this.fb.array([]),
      irbApproval: [this.poster.irbApproval, [Validators.required]],
      conferenceId: [this.poster.conferenceId, [Validators.required]],
      description: [this.poster.description],
      posterSessionId: [this.sessions[0].id, [Validators.required]],
      materials: this.fb.array([]),
    });

    this.loadMaterials();
    this.loadAdditionalAuthors();

    this.posterAssetPath = this.poster.posterAssetPath;
    this.posterThumbnailPath = this.poster.posterThumbnailPath;

    this.initialized = true;
  }

  loadAdditionalAuthors() {
    let additionalAuthors = this.formGroup.get('additionalAuthors') as FormArray;

    if (!this.poster.authors || this.poster.authors.length === 0) {
      return;
    }

    this.poster.authors
      .filter((x) => x.id != this.auth.user.id)
      .forEach((material) => {
        let additionalAuthors = this.formGroup.get('additionalAuthors') as FormArray;
        additionalAuthors.push(
          this.fb.group({
            firstName: [material.firstName, Validators.required],
            lastName: [material.lastName, Validators.required],
            affiliation: [material.affiliation, Validators.required],
            email: [material.email, [Validators.required, Validators.email]],
          })
        );
      });
  }
  loadMaterials() {
    let materials = this.formGroup.get('materials') as FormArray;

    if (!this.poster.materials || this.poster.materials.length === 0) {
      return;
    }

    this.poster.materials.forEach((material) => {
      let materials = this.formGroup.get('materials') as FormArray;
      materials.push(
        this.fb.group({
          description: [material.description, Validators.required],
          fileType: [FileType[material.fileType], Validators.required],
          blobPath: [material.blobPath, Validators.required],
        })
      );
    });
  }

  addRegistrant() {
    this.additionalAuthors = this.formGroup.get('additionalAuthors') as FormArray;
    this.additionalAuthors.push(this.createRegistrant());
  }

  removeRegistrant(index: number): void {
    this.additionalAuthors = this.formGroup.get('additionalAuthors') as FormArray;
    this.additionalAuthors.removeAt(index);
  }

  createRegistrant(): FormGroup {
    return this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      affiliation: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  removeMaterial(index: number): void {
    let materials = this.formGroup.get('materials') as FormArray;
    materials.removeAt(index);
  }

  addMaterial(): void {
    let materials = this.formGroup.get('materials') as FormArray;
    materials.push(this.createMaterial());
  }

  createMaterial(): FormGroup {
    return this.fb.group({
      description: ['', Validators.required],
      fileType: ['', Validators.required],
      blobPath: ['', Validators.required],
    });
  }

  conferenceChange(event) {
    this.posterService.getPosterSessionsForConference(event.target.value).subscribe((sessions) => {
      this.sessions = sessions;
    });
    console.log(event.target.value);
  }

  editImage(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg', backdrop: 'static' }).result.then(
      (result) => {
        this.croppedImage = this.modalImage;
      },
      (reason) => {}
    );
  }

  editThumbnailImage(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg', backdrop: 'static' }).result.then(
      (result) => {
        this.croppedImageThumb = this.modalImageThumb;
      },
      (reason) => {}
    );
  }

  public onSave() {
    if (!this.formGroup.valid) {
      this.formGroup.markAllControlsDirty();
      this.toastr.error('Please fill out all required fields', 'Error');
      return;
    }

    this.submitComplete = new Promise((resetButton:any, reject) => {
      const formData: CreatePosterViewModel = Object.assign({}, this.poster, this.formGroup.value);

      if (this.initialCroppedImage !== this.croppedImage) {
        formData.base64Image = this.croppedImage;
      } else {
        formData.base64Image = null;
      }

      if (this.initialCroppedImageThumb !== this.croppedImageThumb) {
        formData.base64ImageThumb = this.croppedImageThumb;
      } else {
        formData.base64ImageThumb = null;
      }

      if (this.poster.id != null) {
        this.update(formData, resetButton);
      } else {
        this.save(formData, resetButton);
      }
    });
  }

  cancel() {
    this.location.back();
  }

  save(formData: CreatePosterViewModel, resetButton: (result) => any) {
    let posterSessionId = this.formGroup.controls.posterSessionId.value;
    this.posterService.createPoster(posterSessionId, formData).subscribe(
      (user) => {
        this.location.back();
        this.toastr.success('Poster Created', 'Success');
        resetButton(null);
      },
      (error) => resetButton(null)
    );
  }

  update(formData: CreatePosterViewModel, resetButton: (result) => any) {
    this.posterService.updatePoster(this.posterId, formData).subscribe(
      (job) => {
        this.location.back();
        this.toastr.success('Poster Updated', 'Success');
        resetButton(null);
      },
      (error) => resetButton(null)
    );
  }

  navigateBack() {
    this.location.back();
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.modalImage = event.base64;
    console.log(this.initialCroppedImage === this.croppedImage);
  }

  imageLoaded() {
    console.log('loaded');
    // show cropper
  }

  loadImageFailed() {
    // show message
  }

  fileChangeEventThumb(event: any): void {
    this.imageChangedEventThumb = event;
  }

  imageCroppedThumb(event: ImageCroppedEvent) {
    this.modalImageThumb = event.base64;
    console.log(this.initialCroppedImageThumb === this.croppedImageThumb);
    console.log(event.base64);
  }

  imageLoadedThumb() {
    console.log('loaded');
    // show cropper
  }

  loadImageFailedThumb() {
    // show message
  }

  successEventHandler(evt, i) {
    const controlArray = <FormArray>this.formGroup.get('materials');
    controlArray.controls[i].get('blobPath').setValue(evt.response.body.name);
    console.log(evt);
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }
}
